import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from "@angular/core";
import { ILocationInformation } from "@app/interfaces/ILocationInformation";
import { GeocodeService } from "@services/geocode.service";
import { TranslationService } from "@services/translation.service";
import { IVideoEntry } from "../../../../components/videos/models/IVideoEntry";
import './video-address.component.scss';

// Todo : Move to cameras module?
@Component({
    selector: 'video-address',
    template: require('./video-address.component.html')
})
export class VideoAddressComponent implements OnInit, OnChanges {
    @Input() hideEllipsis: boolean = false;
    @Input() videoEntry: IVideoEntry;
    @Input() small: boolean = false;

    debounceTimeout: any;

    label: string = '';

    constructor(
        private geocodeService: GeocodeService,
        private translationService: TranslationService) { }

    ngOnInit() {
        this.initialise();
    }

    ngOnChanges(changes: SimpleChanges) {

        if (!changes["videoEntry"] || this.videoEntryIsSameLocation(changes["videoEntry"])) {
            return;
        }

        this.initialise();
    }

    ngOnDestroy(): void {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
    }

    initialise() {
        // We want a small debounce here, this protects us against fast scrolling - no point updating an address if we have just scrolled past it
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }

        if (!this.videoEntry) {
            return;
        }

        this.debounceTimeout = setTimeout(() => {
            this.updateLabel();
            this.debounceTimeout = null;
        }, 200);
    }

    // ---

    private updateLabel() {
        this.label = '';

        if (this.videoEntry) {
            this.setLabel(true);
        }
        else {
            this.setNoPlotLabel();
        }
    }

    private setNoPlotLabel() {
        this.label = 'N/A';
    }

    private setLabel(showUpdatingText: boolean = false): void {
        if (showUpdatingText) {
            this.label = this.translationService.t('LocationInformation.Updating');
        }

        var videoEntry = this.videoEntry;

        if (!videoEntry.GeocodedAddressId && videoEntry.Latitude != 0 && videoEntry.Longitude != 0) {
            this.geocodeService.getLocationInformationFromVideo(videoEntry.Id).then((address: ILocationInformation) => {
                this.label = address.LocationDescription;
            });
        }
        else {
            this.label = this.videoEntry.PlaceName;
        }
    }
    
    private videoEntryIsSameLocation(videoEntryChange: SimpleChange): boolean {
        if (!videoEntryChange.previousValue) {
            return false;
        }

        return videoEntryChange.currentValue['Latitude'] == videoEntryChange.previousValue['Latitude'] &&
            videoEntryChange.currentValue['Longitude'] == videoEntryChange.previousValue['Longitude'];
    }

}
